// extracted by mini-css-extract-plugin
export default {"container":"container__CTlkC","title":"title__0JMdw","subtitle":"subtitle__Sn8C7","list":"list__ByzBx","item":"item__8eJI9","icon":"icon__dqp0b"};